import { get } from 'lodash';

import { Adapter } from '../interfaces';
import { DetectionEngineNormalizedData } from './models';

export interface DetectionUserEditedEngineV1Inbound {
  readonly engineResults: {
    readonly records: ReadonlyArray<DetectionEngineNormalizedData>;
  };
}

export const detectionUserEditedV1Adapter = (): Adapter<
  DetectionUserEditedEngineV1Inbound,
  DetectionEngineNormalizedData
> => ({ isMatch, adapt });

const isMatch = (i: unknown): i is DetectionUserEditedEngineV1Inbound =>
  get(i, 'engineResults.records[0].jsondata.version', '').startsWith('1.');

const adapt: ReturnType<typeof detectionUserEditedV1Adapter>['adapt'] = ({
  engineResults,
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
}) => engineResults?.records?.[0]!; // TODO: Fix
